"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const QwilrPay = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "59", height: "24", viewBox: "0 0 59 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        opacity: 0.7,
        d: "M14.5838 20.1923L13.0938 18.3446C11.9912 18.9108 10.7097 19.2088 9.36872 19.2088C4.27283 19.2088 0.726562 15.2156 0.726562 9.76208C0.726562 4.27878 4.27283 0.315308 9.36872 0.315308C14.4646 0.315308 18.0407 4.27878 18.0407 9.76208C18.0407 12.4739 17.1169 14.7984 15.5672 16.497L17.0275 18.285L14.5838 20.1923ZM14.1964 9.76208C14.1964 6.18601 12.2892 3.71257 9.36872 3.71257C6.47807 3.71257 4.60063 6.18601 4.60063 9.76208C4.60063 13.3381 6.47807 15.901 9.36872 15.901C9.93493 15.901 10.4713 15.8414 10.9481 15.6924L9.45812 13.8149L11.9018 11.9375L13.3322 13.7255C13.8984 12.7421 14.1964 11.4309 14.1964 9.76208Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M51.9898 23.8328H48.3542L50.2912 18.9753L45.1953 5.59486H49.0992L52.1686 14.4456L55.2083 5.59486H58.9334L51.9898 23.8328ZM44.8117 18.9152H41.2655V18.2C40.8184 18.647 39.4774 19.1536 38.0172 19.1536C35.3352 19.1536 33.0703 17.604 33.0703 14.8325C33.0703 12.2995 35.3352 10.5711 38.2258 10.5711C39.388 10.5711 40.729 10.9585 41.2655 11.3459V10.3625C41.2655 9.23004 40.58 8.30623 39.09 8.30623C38.047 8.30623 37.4212 8.78303 37.1232 9.55785H33.6067C33.9941 7.144 36.1696 5.29637 39.2092 5.29637C42.7555 5.29637 44.8117 7.23341 44.8117 10.4221V18.9152ZM41.2655 15.2795V14.3259C40.9377 13.6107 39.9244 13.1637 38.8516 13.1637C37.6894 13.1637 36.4974 13.6703 36.4974 14.8027C36.4974 15.965 37.6894 16.4418 38.8516 16.4418C39.9244 16.4418 40.9377 15.9948 41.2655 15.2795ZM26.5986 12.5643H22.9331V18.9118H19.1484V0.614319H26.5986C30.4726 0.614319 33.0355 2.70036 33.0355 6.60423C33.0355 10.4783 30.4726 12.5643 26.5986 12.5643ZM29.2806 6.60423C29.2806 4.9652 28.327 3.86258 26.3602 3.86258H22.9331V9.31607H26.3602C28.327 9.31607 29.2806 8.18365 29.2806 6.60423Z"
      }
    )
  );
};
export default QwilrPay;
